/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetVehicleDocumentsResponse,
  GetVehicleMaintenanceResponse,
  GetVehicleResponse,
  ListRequest,
  ListResponseOfDriverSuggestion,
  ListResponseOfVehicleListItem,
  SaveVehicleDocumentRequest,
  SaveVehicleMaintenanceRequest,
  VehicleListExportRequest,
  VehicleWriteRequest
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const createInventoryVehicle = (
    vehicleWriteRequest: VehicleWriteRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<number>(
      {url: `/api/inventory/vehicles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vehicleWriteRequest, signal
    },
      );
    }
  


export const getCreateInventoryVehicleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryVehicle>>, TError,{data: VehicleWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createInventoryVehicle>>, TError,{data: VehicleWriteRequest}, TContext> => {

const mutationKey = ['createInventoryVehicle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInventoryVehicle>>, {data: VehicleWriteRequest}> = (props) => {
          const {data} = props ?? {};

          return  createInventoryVehicle(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInventoryVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof createInventoryVehicle>>>
    export type CreateInventoryVehicleMutationBody = VehicleWriteRequest
    export type CreateInventoryVehicleMutationError = ErrorType<unknown>

    export const useCreateInventoryVehicle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInventoryVehicle>>, TError,{data: VehicleWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInventoryVehicle>>,
        TError,
        {data: VehicleWriteRequest},
        TContext
      > => {

      const mutationOptions = getCreateInventoryVehicleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getInventoryDriverSuggestions = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfDriverSuggestion>(
      {url: `/api/inventory/vehicles/drivers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getGetInventoryDriverSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getInventoryDriverSuggestions>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getInventoryDriverSuggestions>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['getInventoryDriverSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getInventoryDriverSuggestions>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  getInventoryDriverSuggestions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetInventoryDriverSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getInventoryDriverSuggestions>>>
    export type GetInventoryDriverSuggestionsMutationBody = ListRequest
    export type GetInventoryDriverSuggestionsMutationError = ErrorType<unknown>

    export const useGetInventoryDriverSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getInventoryDriverSuggestions>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getInventoryDriverSuggestions>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getGetInventoryDriverSuggestionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const inventoryVehicleList = (
    listRequest: ListRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ListResponseOfVehicleListItem>(
      {url: `/api/inventory/vehicles/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: listRequest, signal
    },
      );
    }
  


export const getInventoryVehicleListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryVehicleList>>, TError,{data: ListRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryVehicleList>>, TError,{data: ListRequest}, TContext> => {

const mutationKey = ['inventoryVehicleList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryVehicleList>>, {data: ListRequest}> = (props) => {
          const {data} = props ?? {};

          return  inventoryVehicleList(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InventoryVehicleListMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryVehicleList>>>
    export type InventoryVehicleListMutationBody = ListRequest
    export type InventoryVehicleListMutationError = ErrorType<unknown>

    export const useInventoryVehicleList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryVehicleList>>, TError,{data: ListRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryVehicleList>>,
        TError,
        {data: ListRequest},
        TContext
      > => {

      const mutationOptions = getInventoryVehicleListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const inventoryVehicleListExport = (
    vehicleListExportRequest: VehicleListExportRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/inventory/vehicles/list/export`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vehicleListExportRequest, signal
    },
      );
    }
  


export const getInventoryVehicleListExportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryVehicleListExport>>, TError,{data: VehicleListExportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryVehicleListExport>>, TError,{data: VehicleListExportRequest}, TContext> => {

const mutationKey = ['inventoryVehicleListExport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryVehicleListExport>>, {data: VehicleListExportRequest}> = (props) => {
          const {data} = props ?? {};

          return  inventoryVehicleListExport(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InventoryVehicleListExportMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryVehicleListExport>>>
    export type InventoryVehicleListExportMutationBody = VehicleListExportRequest
    export type InventoryVehicleListExportMutationError = ErrorType<unknown>

    export const useInventoryVehicleListExport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryVehicleListExport>>, TError,{data: VehicleListExportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryVehicleListExport>>,
        TError,
        {data: VehicleListExportRequest},
        TContext
      > => {

      const mutationOptions = getInventoryVehicleListExportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const updateInventoryVehicle = (
    id: number,
    vehicleWriteRequest: VehicleWriteRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/inventory/vehicles/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: vehicleWriteRequest
    },
      );
    }
  


export const getUpdateInventoryVehicleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryVehicle>>, TError,{id: number;data: VehicleWriteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateInventoryVehicle>>, TError,{id: number;data: VehicleWriteRequest}, TContext> => {

const mutationKey = ['updateInventoryVehicle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInventoryVehicle>>, {id: number;data: VehicleWriteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInventoryVehicle(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInventoryVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof updateInventoryVehicle>>>
    export type UpdateInventoryVehicleMutationBody = VehicleWriteRequest
    export type UpdateInventoryVehicleMutationError = ErrorType<unknown>

    export const useUpdateInventoryVehicle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInventoryVehicle>>, TError,{id: number;data: VehicleWriteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInventoryVehicle>>,
        TError,
        {id: number;data: VehicleWriteRequest},
        TContext
      > => {

      const mutationOptions = getUpdateInventoryVehicleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getInventoryVehicle = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetVehicleResponse>(
      {url: `/api/inventory/vehicles/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetInventoryVehicleQueryKey = (id?: number,) => {
    return [
    `/api/inventory/vehicles/${id}`
    ] as const;
    }

    
export const getGetInventoryVehicleQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryVehicle>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryVehicleQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryVehicle>>> = ({ signal }) => getInventoryVehicle(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInventoryVehicleQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryVehicle>>>
export type GetInventoryVehicleQueryError = ErrorType<void>


export function useGetInventoryVehicle<TData = Awaited<ReturnType<typeof getInventoryVehicle>>, TError = ErrorType<void>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryVehicle>>,
          TError,
          Awaited<ReturnType<typeof getInventoryVehicle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryVehicle<TData = Awaited<ReturnType<typeof getInventoryVehicle>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryVehicle>>,
          TError,
          Awaited<ReturnType<typeof getInventoryVehicle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryVehicle<TData = Awaited<ReturnType<typeof getInventoryVehicle>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicle>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInventoryVehicle<TData = Awaited<ReturnType<typeof getInventoryVehicle>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicle>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInventoryVehicleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const saveInventoryVehicleDocument = (
    vehicleId: number,
    saveVehicleDocumentRequest: SaveVehicleDocumentRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/inventory/vehicles/${vehicleId}/documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveVehicleDocumentRequest, signal
    },
      );
    }
  


export const getSaveInventoryVehicleDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveInventoryVehicleDocument>>, TError,{vehicleId: number;data: SaveVehicleDocumentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveInventoryVehicleDocument>>, TError,{vehicleId: number;data: SaveVehicleDocumentRequest}, TContext> => {

const mutationKey = ['saveInventoryVehicleDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveInventoryVehicleDocument>>, {vehicleId: number;data: SaveVehicleDocumentRequest}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  saveInventoryVehicleDocument(vehicleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveInventoryVehicleDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof saveInventoryVehicleDocument>>>
    export type SaveInventoryVehicleDocumentMutationBody = SaveVehicleDocumentRequest
    export type SaveInventoryVehicleDocumentMutationError = ErrorType<unknown>

    export const useSaveInventoryVehicleDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveInventoryVehicleDocument>>, TError,{vehicleId: number;data: SaveVehicleDocumentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveInventoryVehicleDocument>>,
        TError,
        {vehicleId: number;data: SaveVehicleDocumentRequest},
        TContext
      > => {

      const mutationOptions = getSaveInventoryVehicleDocumentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getInventoryVehicleDocuments = (
    vehicleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetVehicleDocumentsResponse>(
      {url: `/api/inventory/vehicles/${vehicleId}/documents`, method: 'GET', signal
    },
      );
    }
  



export const getGetInventoryVehicleDocumentsQueryKey = (vehicleId?: number,) => {
    return [
    `/api/inventory/vehicles/${vehicleId}/documents`
    ] as const;
    }

    
export const getGetInventoryVehicleDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryVehicleDocuments>>, TError = ErrorType<void>>(vehicleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryVehicleDocumentsQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryVehicleDocuments>>> = ({ signal }) => getInventoryVehicleDocuments(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInventoryVehicleDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryVehicleDocuments>>>
export type GetInventoryVehicleDocumentsQueryError = ErrorType<void>


export function useGetInventoryVehicleDocuments<TData = Awaited<ReturnType<typeof getInventoryVehicleDocuments>>, TError = ErrorType<void>>(
 vehicleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryVehicleDocuments>>,
          TError,
          Awaited<ReturnType<typeof getInventoryVehicleDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryVehicleDocuments<TData = Awaited<ReturnType<typeof getInventoryVehicleDocuments>>, TError = ErrorType<void>>(
 vehicleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryVehicleDocuments>>,
          TError,
          Awaited<ReturnType<typeof getInventoryVehicleDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryVehicleDocuments<TData = Awaited<ReturnType<typeof getInventoryVehicleDocuments>>, TError = ErrorType<void>>(
 vehicleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInventoryVehicleDocuments<TData = Awaited<ReturnType<typeof getInventoryVehicleDocuments>>, TError = ErrorType<void>>(
 vehicleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInventoryVehicleDocumentsQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteInventoryVehicleDocument = (
    vehicleId: number,
    documentId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/inventory/vehicles/${vehicleId}/documents/${documentId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteInventoryVehicleDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryVehicleDocument>>, TError,{vehicleId: number;documentId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryVehicleDocument>>, TError,{vehicleId: number;documentId: number}, TContext> => {

const mutationKey = ['deleteInventoryVehicleDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInventoryVehicleDocument>>, {vehicleId: number;documentId: number}> = (props) => {
          const {vehicleId,documentId} = props ?? {};

          return  deleteInventoryVehicleDocument(vehicleId,documentId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInventoryVehicleDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInventoryVehicleDocument>>>
    
    export type DeleteInventoryVehicleDocumentMutationError = ErrorType<unknown>

    export const useDeleteInventoryVehicleDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInventoryVehicleDocument>>, TError,{vehicleId: number;documentId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInventoryVehicleDocument>>,
        TError,
        {vehicleId: number;documentId: number},
        TContext
      > => {

      const mutationOptions = getDeleteInventoryVehicleDocumentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getInventoryVehicleDocumentFile = (
    vehicleId: number,
    documentId: number,
    fileId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/inventory/vehicles/${vehicleId}/documents/${documentId}/files/${fileId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetInventoryVehicleDocumentFileQueryKey = (vehicleId?: number,
    documentId?: number,
    fileId?: string,) => {
    return [
    `/api/inventory/vehicles/${vehicleId}/documents/${documentId}/files/${fileId}`
    ] as const;
    }

    
export const getGetInventoryVehicleDocumentFileQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>, TError = ErrorType<void>>(vehicleId: number,
    documentId: number,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryVehicleDocumentFileQueryKey(vehicleId,documentId,fileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>> = ({ signal }) => getInventoryVehicleDocumentFile(vehicleId,documentId,fileId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId && documentId && fileId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInventoryVehicleDocumentFileQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>>
export type GetInventoryVehicleDocumentFileQueryError = ErrorType<void>


export function useGetInventoryVehicleDocumentFile<TData = Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>, TError = ErrorType<void>>(
 vehicleId: number,
    documentId: number,
    fileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>,
          TError,
          Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryVehicleDocumentFile<TData = Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>, TError = ErrorType<void>>(
 vehicleId: number,
    documentId: number,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>,
          TError,
          Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryVehicleDocumentFile<TData = Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>, TError = ErrorType<void>>(
 vehicleId: number,
    documentId: number,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInventoryVehicleDocumentFile<TData = Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>, TError = ErrorType<void>>(
 vehicleId: number,
    documentId: number,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleDocumentFile>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInventoryVehicleDocumentFileQueryOptions(vehicleId,documentId,fileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInventoryVehicleMaintenance = (
    vehicleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetVehicleMaintenanceResponse>(
      {url: `/api/inventory/vehicles/${vehicleId}/maintenance`, method: 'GET', signal
    },
      );
    }
  



export const getGetInventoryVehicleMaintenanceQueryKey = (vehicleId?: number,) => {
    return [
    `/api/inventory/vehicles/${vehicleId}/maintenance`
    ] as const;
    }

    
export const getGetInventoryVehicleMaintenanceQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>, TError = ErrorType<void>>(vehicleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryVehicleMaintenanceQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>> = ({ signal }) => getInventoryVehicleMaintenance(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInventoryVehicleMaintenanceQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>>
export type GetInventoryVehicleMaintenanceQueryError = ErrorType<void>


export function useGetInventoryVehicleMaintenance<TData = Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>, TError = ErrorType<void>>(
 vehicleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>,
          TError,
          Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryVehicleMaintenance<TData = Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>, TError = ErrorType<void>>(
 vehicleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>,
          TError,
          Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryVehicleMaintenance<TData = Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>, TError = ErrorType<void>>(
 vehicleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInventoryVehicleMaintenance<TData = Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>, TError = ErrorType<void>>(
 vehicleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenance>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInventoryVehicleMaintenanceQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const saveInventoryVehicleMaintenance = (
    vehicleId: number,
    saveVehicleMaintenanceRequest: SaveVehicleMaintenanceRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/inventory/vehicles/${vehicleId}/maintenance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveVehicleMaintenanceRequest, signal
    },
      );
    }
  


export const getSaveInventoryVehicleMaintenanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveInventoryVehicleMaintenance>>, TError,{vehicleId: number;data: SaveVehicleMaintenanceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveInventoryVehicleMaintenance>>, TError,{vehicleId: number;data: SaveVehicleMaintenanceRequest}, TContext> => {

const mutationKey = ['saveInventoryVehicleMaintenance'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveInventoryVehicleMaintenance>>, {vehicleId: number;data: SaveVehicleMaintenanceRequest}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  saveInventoryVehicleMaintenance(vehicleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveInventoryVehicleMaintenanceMutationResult = NonNullable<Awaited<ReturnType<typeof saveInventoryVehicleMaintenance>>>
    export type SaveInventoryVehicleMaintenanceMutationBody = SaveVehicleMaintenanceRequest
    export type SaveInventoryVehicleMaintenanceMutationError = ErrorType<unknown>

    export const useSaveInventoryVehicleMaintenance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveInventoryVehicleMaintenance>>, TError,{vehicleId: number;data: SaveVehicleMaintenanceRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveInventoryVehicleMaintenance>>,
        TError,
        {vehicleId: number;data: SaveVehicleMaintenanceRequest},
        TContext
      > => {

      const mutationOptions = getSaveInventoryVehicleMaintenanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getInventoryVehicleMaintenanceDocument = (
    vehicleId: number,
    maintenanceId: string,
    documentId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/inventory/vehicles/${vehicleId}/maintenance/${maintenanceId}/documents/${documentId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetInventoryVehicleMaintenanceDocumentQueryKey = (vehicleId?: number,
    maintenanceId?: string,
    documentId?: string,) => {
    return [
    `/api/inventory/vehicles/${vehicleId}/maintenance/${maintenanceId}/documents/${documentId}`
    ] as const;
    }

    
export const getGetInventoryVehicleMaintenanceDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>, TError = ErrorType<void>>(vehicleId: number,
    maintenanceId: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInventoryVehicleMaintenanceDocumentQueryKey(vehicleId,maintenanceId,documentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>> = ({ signal }) => getInventoryVehicleMaintenanceDocument(vehicleId,maintenanceId,documentId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId && maintenanceId && documentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInventoryVehicleMaintenanceDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>>
export type GetInventoryVehicleMaintenanceDocumentQueryError = ErrorType<void>


export function useGetInventoryVehicleMaintenanceDocument<TData = Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>, TError = ErrorType<void>>(
 vehicleId: number,
    maintenanceId: string,
    documentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>,
          TError,
          Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryVehicleMaintenanceDocument<TData = Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>, TError = ErrorType<void>>(
 vehicleId: number,
    maintenanceId: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>,
          TError,
          Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInventoryVehicleMaintenanceDocument<TData = Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>, TError = ErrorType<void>>(
 vehicleId: number,
    maintenanceId: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInventoryVehicleMaintenanceDocument<TData = Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>, TError = ErrorType<void>>(
 vehicleId: number,
    maintenanceId: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInventoryVehicleMaintenanceDocument>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInventoryVehicleMaintenanceDocumentQueryOptions(vehicleId,maintenanceId,documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




